module.exports = [["value","label","pattern","vendors[]","color"],["none","No Thanks","","",""]]